import request from '@/utils/request'

export default {
    taskInfo: function (id, bizId, y) {
        return request({
            url: 'task/info',
            method: 'post',
            params: {jobId: id, bizId: bizId, y: y}
        });
    },
    signUp: function (id, account, linkAtrr1, linkAtrr2) {
        return request({
            url: 'task/signUp',
            method: 'get',
            params: {jobId: id, account: account, linkAtrr1: linkAtrr1, linkAtrr2: linkAtrr2}
        });
    },
    list: function (form) {
        return request({
            url: 'task/list',
            method: 'post',
            data: form
        });
    },
    index: function () {
        return request({
            url: 'task/main/index',
            method: 'post',
        })
    },
    getJdProvince: function (bizId) {
        return request({
            url: 'task/getJdProvince',
            method: 'get',
            params: {bizId: bizId}
        })
    },
    jobOrderDeclare: function (form) {
        return request({
            url: 'task/jobOrderDeclare',
            method: 'post',
            data: form
        })
    },
    simpleJobOrderDeclare: function (form) {
        return request({
            url: 'task/simpleJobOrderDeclare',
            method: 'post',
            data: form
        })
    },
    getJobOrderDeclarePage: function (form) {
        return request({
            url: 'task/getJobOrderDeclarePage',
            method: 'post',
            data: form
        })
    },
    ccbJobOrderDeclare: function (form) {
        return request({
            url: 'task/ccbJobOrderDeclare',
            method: 'post',
            data: form
        })
    },
    getInfoByTraderId: function (jobId, traderId, mid) {
        return request({
            url: 'task/getInfoByTraderId',
            method: 'post',
            params: {jobId: jobId, traderId: traderId, mid: mid}
        });
    },
    changeOrderByTraderId: function (jobId, traderId, mid) {
        return request({
            url: 'task/changeOrderByTraderId',
            method: 'post',
            params: {jobId: jobId, traderId: traderId, mid: mid}
        });
    },
    signContract: function (companyName, unifiedCreditCode, phone) {
        return request({
            url: 'task/signContract',
            method: 'post',
            params: {companyName: companyName, unifiedCreditCode: unifiedCreditCode, phone:phone}
        });
    },
    jobOrderFormApply: function (form) {
        return request({
            url: 'task/jobOrderFormApply',
            method: 'post',
            data: form
        })
    },
    jobOrderFormApplyList: function (form) {
        return request({
            url: 'task/jobOrderFormApplyList',
            method: 'post',
            data: form
        })
    },

}
